import { render, staticRenderFns } from "./HbBtn.vue?vue&type=template&id=0954660c&scoped=true&"
import script from "./HbBtn.vue?vue&type=script&lang=js&"
export * from "./HbBtn.vue?vue&type=script&lang=js&"
import style0 from "./HbBtn.vue?vue&type=style&index=0&id=0954660c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954660c",
  null
  
)

export default component.exports